import { adminApiClient } from './adminApiClient';

// ---------------------------------------------------------------------------
// Types — modeled on origami/storage/api-docs/admin-api-docs.json:10456-10645
// ---------------------------------------------------------------------------

export interface TraceListItem {
  trace_id: string;
  timestamp: string;
  span_name: string | null;
  http_method: string | null;
  http_route: string | null;
  url_path: string | null;
  status_code: string;
  http_status: number | null;
  duration_ms: number;
  user_id: string | null;
  tenant_id: string | null;
  service_name: string;
}

export interface SpanEvent {
  timestamp: string;
  name: string;
  attributes?: Record<string, string>;
}

export interface Span {
  span_id: string;
  parent_span_id: string;
  name: string;
  kind: string;
  timestamp: string;
  duration_ns: number;
  status_code: string;
  status_message?: string;
  attributes?: Record<string, string>;
  events?: SpanEvent[];
}

export interface TraceDetail {
  trace_id: string;
  service_name: string;
  root_span_id: string | null;
  started_at: string;
  duration_ms: number;
  user_id: string | null;
  tenant_id: string | null;
  spans: Span[];
}

export interface TraceListParams {
  from: string;
  to: string;
  user_id?: string;
  tenant_id?: string;
  status?: 'ok' | 'error';
  route?: string;
  per_page?: number;
  cursor?: string;
}

export interface TraceListMeta {
  next_cursor?: string | null;
  [key: string]: unknown;
}

// ---------------------------------------------------------------------------
// Service
// ---------------------------------------------------------------------------

const basePath = '/admin/observability/traces';

export const tracesService = {
  async list(
    params: TraceListParams,
  ): Promise<{ data: TraceListItem[]; meta: TraceListMeta }> {
    const response = await adminApiClient.get<{
      data: TraceListItem[];
      meta: TraceListMeta;
    }>(basePath, { params });
    return response.data;
  },

  async get(traceId: string): Promise<{ data: TraceDetail }> {
    const response = await adminApiClient.get<{ data: TraceDetail }>(
      `${basePath}/${traceId}`,
    );
    return response.data;
  },
};
